import { createSelector } from '@reduxjs/toolkit';

import { COLLECTION_IDS } from '@/constants/collections';
import configSelector from '@/features/config/selectors/config';

const immutableFilterQueriesSelector = createSelector(
  configSelector,
  ({
    // Immutable Filter Values
    cities,
    countries,
    dealers,
    dealerships,
  }) => {
    const q: string[] = [];
    const qMap: Record<string, string> = {};

    const immutableFilters = {
      [COLLECTION_IDS.dealersCities]: cities,
      [COLLECTION_IDS.dealersCountries]: countries,
      [COLLECTION_IDS.dealersDealers]: dealers,
      [COLLECTION_IDS.dealersDealership]: dealerships,
    };

    for (const [collectionId, value] of Object.entries(immutableFilters)) {
      if (collectionId && value) {
        const collectionCondition = `locations.collection_id == "${collectionId}"`;
        const resolvedValue = Array.isArray(value) ? value : [value];
        if (resolvedValue.length) {
          const valueCondition = `locations.id in ["${resolvedValue.join('", "')}"]`;
          const query = `${collectionCondition} && ${valueCondition}`;
          q.push(query);
        }
      }
    }

    return { q, qMap };
  },
);

export default immutableFilterQueriesSelector;
